module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//gorilla_6_1.png?v=3313ad0e";